import ApiService from "./api.service";
import store from "../store/mainStore"

class SettingsService extends ApiService {
    setVotingChartType(data) {
        return this.post(`api/management/settings/setVotingChartType`, data);
    }

    setLogoSetting(data) {
        return this.post(`api/management/settings/setLogoSetting`, data);
    }

    setLogoClientImage(data) {
        return this.post(`api/management/settings/setLogoClientImage`, data);
    }

    async getLogoClientImage() {
        let response = await this.get(`api/management/settings/getLogoClientImage`);

        if(response.status !== 200 && response.status !== 204)
        {
            throw await Promise.reject(response);
        }

        if(response.status === 200){
            store.commit("setLogoBase64", response.data.image);
        }

        return response
    }

    getFooterClientImage() {
        return this.get(`api/management/settings/getFooterClientImage`);
    }

    deleteLogoClientImage() {
        return this.delete(`api/management/settings/deleteLogoClientImage`);
    }

    deleteFooterClientImage() {
        return this.delete(`api/management/settings/deleteFooterClientImage`);
    }

    setFooterClientImage(data) {
        return this.post(`api/management/settings/setFooterClientImage`, data);
    }

    setCameraApiAddress(data) {
        return this.post(`api/management/settings/setCameraApiAddress`, data);
    }

    async getClientType() {
        let response = await this.get(`api/management/settings/getClientType`);
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        await store.commit("setClientTypeConfiguration", response.data);
        return response;
    }

    getIntegrationAuthData() {
        return this.get(`api/management/settings/getIntegrationAuthData`);
    }

    /*
     * Wlasny adres okna wizualizacji (/Visualization/{adres}) - ustawienia integracji.
     * Zapis i sprawdzenie zwracaja ten sam ksztalt: { isValid, slug, error }. Odrzucony zapis to 422,
     * bo globalny interceptor axiosa pokazuje wlasny komunikat dla kazdego kodu poza 404 i 422.
     */
    getVisualizationLink() {
        return this.get(`api/management/settings/visualization-link`);
    }

    validateVisualizationLink(slug) {
        return this.post(`api/management/settings/visualization-link/validate`, { slug });
    }

    saveVisualizationLink(slug) {
        return this.post(`api/management/settings/visualization-link`, { slug });
    }

    getVisualizationLinkActivity(page, pageSize) {
        return this.get(`api/management/settings/visualization-link/activity?page=${page}&pageSize=${pageSize}`);
    }

    exportVisualizationLinkActivity(format) {
        return this.post(`api/management/settings/visualization-link/activity/export`, { format }, { responseType: "arraybuffer" });
    }

    async updateClientSettings(data)
    {
        let response = await this.post(`api/management/settings/update-client-settings`, data);
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        await this.getUserSettings();
        await this.getRuntimeSettings();
        await store.commit("setClientSettings", response.data);

        return response;
    }

    async updateUserVotingSettings(data)
    {
        let response = await this.post(`api/management/settings/update-user-voting-settings`, data);
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        await this.getClientSettings();
        await this.getRuntimeSettings();
        await store.commit("setUserSettings", response.data);

        return response;
    }

    async getClientSettings(){
        let response = await this.get(`api/management/settings/client-settings`);
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        await store.commit("setClientSettings", response.data);
        await this.getVotingAllowedIp();
        return response;
    }

    async getUserSettings(){
        let response = await this.get(`api/management/settings/user-settings`);
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        await store.commit("setUserSettings", response.data);
        await this.getVotingAllowedIp();
        return response;
    }

    async getRuntimeSettings(){
        let response = await this.get(`api/management/settings/runtime-settings`);
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        await store.commit("setRuntimeSettings", response.data);
        await this.getVotingAllowedIp();
        return response;
    }

    async getVotingAllowedIp() {
        let response = await this.get(`api/management/settings/voting-allowed-ip`);
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        await store.commit("setAllowIpAddress", response.data);
        return response;
    }

    async setVotingAllowedIp(ip) {
        let response = await this.post(`api/management/settings/voting-allowed-ip`, {
            allowedIp: ip
        });

        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        return await this.getVotingAllowedIp();
    }

    async setHideVotingResultsDuringVoting(hideVotingResultsDuringVoting) {
        const response = await this.post(`api/management/settings/hide-results-during-voting`, {
            hideVotingResultsDuringVoting,
        });

        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        return response;
    }
}

export default new SettingsService();
